import {SSLFormState} from './SSLForm-State'
import {errorsList, errorsPresent, mergeServerValidationErrors} from '../../../../../helpers/ErrorHelper'
import {isObject} from "../../../../../helpers/DataHelper";

export default function SSLFormReducer(state = SSLFormState, action) {

    let {data} = {...state};
    let {validationErrors, name, value, mode, error, site_id,sslCertificate} = action;
    switch (action.type) {

        case 'ON-SSL-CERTIFICATES-FORM-CHANGE':
                data.payload[name] = value;
            buildErrors();
            return {...state, data};

        case 'ON-DELETE-SSL-CERTIFICATES-FORM':
            data.payload['paths'] = value;
            buildErrors();
            return {...state, data};

        case 'ON-SSL-CERTIFICATES-FORM-MODE-CHANGE':
            data.mode = mode;
            buildErrors();
            return {...state, data};

        case 'SET-SSL-CERTIFICATES-ERROR':
            data.message = error;
            buildErrors();
            return {...state, data};

        case 'SET-SITE-ID':
            data.site_id = site_id;
            buildErrors();
            return {...state, data};

        case 'SET-DEFAULT-SSL-CERTIFICATES-FORM':
            data = {
                payload: {
                    name: "",
                    key_content: "",
                    certificate: "",
                },
                errors: [],
                errorsPresent: false,
                submitted: false,
                dispatchAPI: false,
                mode: `create`,
                message: ``
            };
            buildErrors();
            return {...state, data};

        case 'SET-SSL-DATA-FOR-UPDATE':

            data.payload = {
                name: sslCertificate.name,
                key_content: sslCertificate.key,
                certificate: sslCertificate.certificate,
            };
            buildErrors();
            return {...state, data};

        case 'CANCEL-SSL-CERTIFICATES-FORM-DISPATCH':
            data.dispatchAPI = false;
            data.submitted = false;
            buildErrors();
            return {...state, data};

        case 'ON-SSL-CERTIFICATES-FORM-SUBMIT':
            data.submitted = true;
            buildErrors();
            if (!data.errorsPresent) data.dispatchAPI = true;
            return {...state, data};

        case 'SSL-CERTIFICATES-FORM-SERVER-VALIDATION-ERRORS':
            validationErrors && isObject(validationErrors) &&
            Object.keys(validationErrors).map(key =>
                data.errors[key] = [{message: ` - ${validationErrors[key][0]}`.slice(0, -1)}]
            );
            data.dispatchAPI = false;
            return {...state, data};

        default:
            return state
    }

    function buildErrors() {
        data.errors = errorsList(errors)
        data.errorsPresent = errorsPresent(errors)
    }

    function errors(field) {
        let {payload, submitted, validationErrors} = data;
        let errors = {};
        Object.keys(payload).map(key => errors[key] = []);

        if (submitted) {
            if (field === `name`) {
                if (!_(field)) newError(field, 0, `certificate name field is required`)
            }
            if (field === `key_content`) {
                if (!_(field)) newError(field, 0, `.key contents field is required`)
            }
            if (field === `certificate`) {
                if (!_(field)) newError(field, 0, `.cert contents field is required`)
            }
        }

        errors = mergeServerValidationErrors(errors, validationErrors)

        return field ? errors[field] : errors

        function newError(field, step, message) {
            errors && errors[field].push({step, message})
        }

        function _(field) {
            return data.payload[field]
        }
    }
}
